import { getFullUrlPure } from 'hubspot-url-utils/pure';
import * as ClassicHublets from 'hubspot-url-utils/hublets';
import * as Hublets from 'hubspot-url-utils/hublets-next';
import { MagpieConfigManager } from '../models/config/config-manager';
const curriedGetOrigin = subdomain => env => hublet => getFullUrlPure(subdomain, hublet, env);
const getPreviewOrigin = (portalId, isQA) => hublet => `https://${portalId}.hubspotpreview${isQA ? 'qa' : ''}-${hublet}.com`;
export const getAllowedOrigins = () => {
  const classicHublets = Object.values(ClassicHublets);
  const hublets = Object.values(Hublets);
  const getLocal = curriedGetOrigin('local');
  const getApp = curriedGetOrigin('app');
  const getLocalQA = getLocal('qa');
  const getAppQA = getApp('qa');
  const getLocalProd = getLocal('prod');
  const getAppProd = getApp('prod');
  const portalId = MagpieConfigManager.getInstance().get('portalId');
  const localQa = classicHublets.map(getLocalQA);
  const qa = classicHublets.map(getAppQA);
  const localProd = hublets.map(getLocalProd);
  const prod = hublets.map(getAppProd);
  const localTestEnv = 'https://local.hsappstatic.net';
  const staticTestEnv = 'https://static.hsappstatic.net';
  const previewOrigins = portalId ? [...hublets.map(getPreviewOrigin(portalId, false)), ...hublets.map(getPreviewOrigin(portalId, true))] : [];
  return [...localQa, ...qa, ...localProd, ...prod, ...previewOrigins, localTestEnv, staticTestEnv];
};